import {
  Card,
  CardCaption,
  EducationScreen,
  Gold,
  RevealBlock,
  ScreenBody,
  ScreenIntro,
  ScreenSubhead,
} from './EducationShell';
import {StaticStepList, StepperCarouselViz, type Step11Brand, type Step11Step} from './Step11Viz';
import {ZepboundDisclaimer} from './ZepboundDisclaimer';
import styles from './Glp1EducationLegitimacyBranded.module.css';

const STEPS: Step11Step[] = [
  {
    title: 'A real clinical screening',
    short: 'Screening',
    detail:
      "Same questions a sleep-medicine doctor would ask in clinic, so you only get prescribed what's right for you. Validated against in-lab polysomnography.",
  },
  {
    title: 'A clinician reviews your case',
    short: 'Review',
    detail: 'They titrate your dose for sleep apnea, not weight loss. Not an algorithm, not a checkbox form.',
  },
  {
    title: "You only pay if it's the right fit",
    short: 'Right fit',
    detail:
      "If your clinician decides this isn't right for you, you get a full refund automatically. No proof, no paperwork.",
  },
  {
    title: 'Your medication arrives safely',
    short: 'Delivery',
    detail: 'Zepbound® shipped directly from pharmacy, tracked end to end.',
  },
  {
    title: 'A clinician on call',
    short: 'Support',
    detail: 'Message your provider anytime with questions about dosing, side effects, or anything that comes up.',
  },
];

const BRAND: Step11Brand = {
  rxName: 'Zepbound® 10mg',
  rxDosage: 'Weekly · titrating schedule for severe OSA',
  pharmacy: 'Pharmacy',
  deliveryLabel: 'Out for delivery',
};

/** Step 11 — branded. Clinical legitimacy of RISE Expert Care. */
export const Glp1EducationLegitimacyBranded = () => (
  <EducationScreen
    ctaLabel="Next"
    variant="branded_v1"
    analyticsShown="GLP-1 Funnel Education Legitimacy Viewed"
    analyticsSubmitted="GLP-1 Funnel Education Legitimacy Continue Tapped"
  >
    <ScreenIntro
      headline={
        <>
          A real clinician. A real prescription. <Gold>Real progress.</Gold>
        </>
      }
      subhead="RISE Expert Care brings a daily sleep practice and real medical care together in one place."
    />

    <RevealBlock delayMs={300}>
      <Card>
        <StepperCarouselViz steps={STEPS} brand={BRAND} />
        <CardCaption>Your case is reviewed by a real doctor before anything ships.</CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <StaticStepList
        items={STEPS}
        title={
          <h3 className={styles.listHeading}>
            A <Gold>licensed clinician</Gold> guides every step
          </h3>
        }
      />
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <ScreenSubhead>The complete solution</ScreenSubhead>
      <ScreenBody>
        RISE Expert Care is the comprehensive solution for sleep apnea: a daily sleep practice through the RISE app,
        plus medication for the airway physiology that habits alone can&apos;t fix, plus a real clinician you can
        message. If the medication isn&apos;t right for you, you get a full refund automatically.
      </ScreenBody>
    </RevealBlock>

    <RevealBlock delayMs={600}>
      <ZepboundDisclaimer />
    </RevealBlock>
  </EducationScreen>
);

export default Glp1EducationLegitimacyBranded;
